// Google keys
export const GoogleAPIKey = 'AIzaSyD1nofLVhaLWa_vjBZbofTQPdiKx8qxTBs';

// subtypes
export const SUBTYPE_NEW = 'new';
export const SUBTYPE_CREATE = 'create';
export const SUBTYPE_UPDATE = 'update';
export const SUBTYPE_SEND = 'send';
export const SUBTYPE_DELETE = 'delete';
export const SUBTYPE_DRAWING = 'drawing';
export const SUBTYPE_UNKNOWN = 'unknown';
